export interface FeaturedSlide {
  id: string;
  kicker: string;
  title: string;
  subtitle: string;
  articleId: string;
  image: string;
}

export interface Topic {
  id: string;
  name: string;
  desc: string;
  icon: string;
  cover: string;
  articleIds: string[];
}

export const featuredSlides: FeaturedSlide[] = [
  {
    id: "slide-1",
    kicker: "焦点专题",
    title: "乱伦相关法律体系综述",
    subtitle: "从禁婚亲属制度到刑事规制，系统梳理与近亲性关系相关的法律框架与制度衔接。",
    articleId: "laws-01",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20elegant%20dark%20navy%20blue%20banner%20background%20with%20subtle%20silhouettes%20of%20scales%20of%20justice%20and%20classical%20columns%2C%20fine%20geometric%20lines%20and%20soft%20golden%20light%2C%20authoritative%20professional%20legal%20atmosphere%2C%20wide%20cinematic%20composition%2C%20no%20people&width=1600&height=720&seq=banner-law-2026a&orientation=landscape",
  },
  {
    id: "slide-2",
    kicker: "深度解析",
    title: "伦理道德层面的理性讨论",
    subtitle: "回到伤害原则与知情同意，看清禁忌背后的实质理由，保持克制而有说服力的论证。",
    articleId: "ethics-01",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20deep%20navy%20and%20teal%20background%20with%20balanced%20smooth%20stone%20forms%20and%20soft%20theoretical%20light%20lines%2C%20serene%20philosophical%20mood%2C%20minimal%20elegant%20wide%20composition%2C%20no%20people&width=1600&height=720&seq=banner-ethics-2026a&orientation=landscape",
  },
  {
    id: "slide-3",
    kicker: "案例教学",
    title: "从虚构个案理解法律适用",
    subtitle: "以去标识化的教学案例，示范婚姻效力、刑事量刑与未成年人保护的分析思路。",
    articleId: "cases-01",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20navy%20background%20with%20a%20wooden%20gavel%20and%20case%20files%20rendered%20in%20soft%20studio%20light%2C%20subtle%20red%20accent%20line%2C%20professional%20legal%20case%20atmosphere%2C%20wide%20editorial%20composition%2C%20no%20people&width=1600&height=720&seq=banner-case-2026a&orientation=landscape",
  },
];

export const topics: Topic[] = [
  {
    id: "topic-norms",
    name: "社会规范专题",
    desc: "从家庭信任与社会功能出发，理解亲属边界为何重要。",
    icon: "ri-community-line",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20paper%20cut%20illustration%20of%20interlocking%20protective%20arcs%20symbolizing%20community%20and%20norms%2C%20muted%20navy%20teal%20and%20warm%20neutral%20tones%2C%20clean%20minimal%20editorial%20design%2C%20no%20faces&width=600&height=400&seq=topic-norms-2026a&orientation=landscape",
    articleIds: ["ethics-04", "ethics-05", "laws-05"],
  },
  {
    id: "topic-boundary",
    name: "法律边界专题",
    desc: "禁婚范围、婚姻效力与刑事规制，划清法律允许与否的界线。",
    icon: "ri-git-branch-line",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20geometric%20line%20drawing%20of%20a%20clear%20boundary%20with%20a%20path%20and%20a%20stop%20marker%2C%20deep%20navy%20background%20with%20subtle%20red%20accent%2C%20modern%20minimal%20legal%20concept%2C%20no%20people&width=600&height=400&seq=topic-boundary-2026a&orientation=landscape",
    articleIds: ["laws-01", "laws-04", "laws-03"],
  },
  {
    id: "topic-protect",
    name: "未成年人保护专题",
    desc: "强制报告、保护令与监护权撤销，构建对未成年人的持续保护。",
    icon: "ri-shield-star-line",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20protective%20shield%20made%20of%20soft%20paper%20cut%20layers%20in%20muted%20teal%20and%20navy%20tones%2C%20warm%20calm%20editorial%20illustration%20concept%2C%20no%20faces&width=600&height=400&seq=topic-protect-2026a&orientation=landscape",
    articleIds: ["laws-05", "cases-03", "cases-04"],
  },
  {
    id: "topic-ethics",
    name: "伦理方法专题",
    desc: "伤害原则、同意理论到道德情感，学习如何做一次严谨的伦理推理。",
    icon: "ri-lightbulb-flash-line",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20of%20balanced%20matte%20spheres%20and%20soft%20gradient%2C%20muted%20navy%20teal%20beige%20palette%2C%20calm%20philosophical%20editorial%20concept%2C%20no%20people&width=600&height=400&seq=topic-ethics-2026a&orientation=landscape",
    articleIds: ["ethics-01", "ethics-02", "ethics-03"],
  },
];